import { Outlet } from 'react-router'
import { NavigationBar } from './NavigationBar'

export function MainLayout() {
  return (
    <main className="surface-50 min-h-screen">
      <NavigationBar />
      <div className="px-3 sm:px-5">
        <div className="max-w-app mx-auto pb-8">
          <Outlet />
        </div>
      </div>
    </main>
  )
}
